import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  role: null,
  permissions: [],
  error: "", // for error message
  loading: false,
  isUserLogout: false,
  errorMsg: false, // for error
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    loginBegin(state, action) {
      state.loading = true;
    },
    apiError(state, action) {
      state.errorMsg = action.payload?.message || action.payload?.data || action.payload || "An error occurred";
      state.loading = false;
      state.error = true;
      state.isUserLogout = false;
    },
    loginSuccess(state, action) {
      state.user = action.payload.user || action.payload;
      state.role = action.payload.role || null;
      state.permissions = action.payload.permissions || [];
      state.loading = false;
      state.error = false;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
      state.user = {};
      state.role = null;
      state.permissions = [];
    },
    reset_login_flag(state) {
      state.errorMsg = null
      state.loading = false;
      state.error = false;
    }
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  loginBegin
} = loginSlice.actions

export default loginSlice.reducer;